import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum AdmissionsAcceleratorsPageTabId {
	Accelerators = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsAcceleratorsPageViewId {
	Accelerators = 1,
	Teams = 2,
	AcceleratorSeats = 3,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsAcceleratorsService extends PageTabsLayoutPageService<AdmissionsAcceleratorsPageTabId, AdmissionsAcceleratorsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsAcceleratorsPageViewId>[] = [
		{
			uniqueId: AdmissionsAcceleratorsPageViewId.Accelerators, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Accelerators',
				hideText: 'never',
			}, customSort: '1-Accelerators-1'
		},
		{
			uniqueId: AdmissionsAcceleratorsPageViewId.Teams, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Teams',
				hideText: 'never',
			}, customSort: '1-Accelerators-2'
		},
		{
			uniqueId: AdmissionsAcceleratorsPageViewId.AcceleratorSeats, iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Accelerator Seats',
				hideText: 'never',
			}, customSort: '1-Accelerators-3'
		},

	];


	constructor() {
		super(AdmissionsAcceleratorsService._viewDroplistItems, AdmissionsAcceleratorsService.name, AdmissionsAcceleratorsPageTabId.Accelerators, AdmissionsAcceleratorsPageViewId.Accelerators);
	}

	public get viewId() {
		return AdmissionsAcceleratorsPageViewId;
	}

}